// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nul[data-v-ec8334b2] {\r\n  width: 100%;\r\n  display: table;\r\n  table-layout: fixed;\r\n  border-collapse: collapse;\r\n  margin-top: 10px;\n}\nli[data-v-ec8334b2] {\r\n  display: table-cell;\r\n  text-align: center;\r\n  border: 1px solid gray;\r\n  vertical-align: middle;\r\n  word-wrap: break-word;\n}\n.gray[data-v-ec8334b2] {\r\n  background-color: gainsboro;\n}\r\n", ""]);
// Exports
module.exports = exports;
